import '../../style/App.css';
import { Popover } from '@base-ui-components/react/popover';

const WidgetPopUp = ({trigger, popUp, onOpenChange, popOverClass, popOverClassContainer, alignOffset, sideOffset, triggerClass, openOnHover=false, align='end', side='bottom', disabled=false, modal=false}) => {
    return <Popover.Root onOpenChange={onOpenChange} openOnHover={openOnHover} modal={'trap-focus'}>
                <Popover.Trigger className={`widgetPopupTrigger ${triggerClass}`} onClick={(event) => event.stopPropagation()} disabled={disabled}>
                    {trigger}
                </Popover.Trigger>
                <Popover.Portal>
                    <Popover.Positioner align={align} side={side} sticky={true} alignOffset={alignOffset} sideOffset={sideOffset}>
                        <Popover.Popup className={`${popOverClassContainer} widgetPopover editHpGrow`}>
                            <Popover.Description className={popOverClass} render={<div/>} onClick={(event) => event.stopPropagation()}>
                                {popUp}
                            </Popover.Description>
                        </Popover.Popup>
                    </Popover.Positioner>
                </Popover.Portal>
            </Popover.Root>;
};

export default WidgetPopUp;